import React, { useRef, useState } from 'react'
import  "./image.css";
import  default_image  from "../Assets/default_image.svg";

const ImageG = () => {

    const [image_url,setimage_url] = useState("/");
    let inputRef = useRef(null)
    const [loading,setloading] = useState(false);

    const clickgenerat = async () => {
        if (inputRef.current.value == "") {
            return 0;
        }
        setloading(true);
        const response = await fetch("https://api.openai.com/v1/images/generations ",{
            method:"POST",
            headers:{
                "Content-Type":"application/json",
                Authorization:"Bearer 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",
                "User-Agent":"Chrome",
            },
            body:JSON.stringify({
                prompt:`${inputRef.current.value}`,
                n:1,
                size:"512x512"
            }),
        })
        let data = await response.json();
        let data_arry = data.data;
        setimage_url(data_arry[0].url);
        setloading(false);
    }

  return (
    <div className='ai-image'>
        <div className="header">AI Image <span>Generator</span></div>
        <div className="img-loading">
            <div className="image"><img src={image_url === "/"?default_image:image_url} alt="" />
            <div className={loading?"loading-par-full":"loading-bar"}>
                <div className={loading?"loading-text":"display-none"}>
                    Loading .....
                </div>
            </div>
            </div>
        </div>
        <div className="search-box">
            <input type="text" className='search-inp' placeholder='What Uou Want To See'
                ref={inputRef}
               
            />
            <button className='btn-Generator' onClick={()=>{clickgenerat()}}>Generate</button>
        </div>
    </div>
  )
}

export default ImageG